var MemoCategoryGraph = /** @class */ (function () {
    function MemoCategoryGraph() {
        this.typeLabels = [];
        this.barOptions = {
            scaleShowVerticalLines: false,
            responsive: true,
            tooltips: { enabled: false },
            scales: {
                xAxes: [
                    {
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: false
                        },
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }
                ]
            }
        };
        this.barColors = [
            {
                backgroundColor: [
                    'rgba(79,177,166,0.6)',
                    'rgba(79,177,166,1.0)',
                    'rgba(79,177,166,0.6)',
                    'rgba(79,177,166,1.0)',
                    'rgba(79,177,166,0.6)',
                    'rgba(79,177,166,1.0)',
                    'rgba(79,177,166,0.6)',
                    'rgba(79,177,166,1.0)',
                    'rgba(79,177,166,0.6)',
                    'rgba(79,177,166,1.0)',
                    'rgba(79,177,166,0.6)',
                    'rgba(79,177,166,1.0)',
                    'rgba(79,177,166,0.6)',
                    'rgba(79,177,166,1.0)',
                    'rgba(79,177,166,0.6)',
                    'rgba(79,177,166,1.0)'
                ]
            }
        ];
    }
    Object.defineProperty(MemoCategoryGraph.prototype, "data", {
        set: function (categories) {
            this.typeLabels = categories.map(function (cat) { return cat.name; });
            this.typeData = categories.map(function (cat) { return cat.score; });
        },
        enumerable: true,
        configurable: true
    });
    return MemoCategoryGraph;
}());
export { MemoCategoryGraph };
